module.exports = __webpack_public_path__ + "img/normaluse.85791422.png";